module.exports = __webpack_public_path__ + "img/Poster1.8071e21e.png";